import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export function LanguageSelector({ variant = "light" }) {
  const { lang, setLang, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang) || languages[0];

  useEffect(() => {
    const onClick = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const trigger =
    variant === "onImage"
      ? "bg-white/15 text-white backdrop-blur hover:bg-white/25 border border-white/20"
      : "bg-white text-primary border border-border hover:border-primary/40";

  return (
    <div className="absolute top-4 right-4 z-40" ref={ref}>
      <button
        data-testid="language-selector-btn"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold shadow-sm transition-colors ${trigger}`}
      >
        <Globe className="h-4 w-4" /> {current.short}
      </button>
      {open && (
        <ul
          data-testid="language-menu"
          className="absolute right-0 mt-2 w-44 overflow-hidden rounded-2xl border border-border bg-white shadow-lg"
        >
          {languages.map((l) => (
            <li key={l.code}>
              <button
                data-testid={`language-option-${l.code}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between px-4 py-3 text-left text-sm transition-colors hover:bg-secondary ${
                  l.code === lang ? "font-semibold text-primary bg-secondary/60" : "text-foreground"
                }`}
              >
                {l.label}
                {l.code === lang && <Check className="h-4 w-4 text-primary" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
